import { Box, Typography } from '@mui/material';

import { OUR_VISION, VISION_DESCRIPTION } from './constants';

export const SbsVision = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ m: 0 }}
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={3}
      textAlign="center"
    >
      {/* Text Section */}
      <Box flex={1}>
        <Box maxWidth={{ xs: 343, md: 375, lg: 556 }} mx={'auto'}>
          <Typography
            gutterBottom
            sx={{
              textWrap: 'pretty',
              fontSize: { xs: '30px', md: '42px' },
              fontWeight: '700',
              lineHeight: { xs: '38.4px', md: '61.44px' },
              fontFamily: 'sans-serif',
            }}
          >
            {OUR_VISION}
          </Typography>
          <Typography
            sx={{
              textWrap: 'pretty',
              fontSize: { xs: '14px', md: '16px' },
              lineHeight: { xs: '22.4px', md: '28.8px' },
              color: '#727272',
              m: { lg: '0 50px' },
              fontFamily: 'sans-serif',
            }}
            gutterBottom
          >
            {VISION_DESCRIPTION}
          </Typography>
        </Box>
      </Box>

      {/* Visual Section */}
      <Box
        flex={1}
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        mb={4}
        position="relative"
        overflow="hidden"
      >
        <Box
          component="img"
          src="https://res.cloudinary.com/amunoali/image/upload/v1742152952/CashClever/46_mwrj7j.png" // Replace with your image URL
          alt="Placeholder"
          sx={{
            maxWidth: { xs: 343, lg: 465 },
            minHeight: { xs: 300, lg: 407 },
            borderRadius: '1rem',
            objectFit: 'cover',
            filter: 'grayscale(80%)',
            position: 'relative',
            width: { xs: '100%', md: 'auto' },
          }}
        />
      </Box>
    </Box>
  );
};
